import TroubleManagerContainer from "./TroubleManagerContainer";

export default TroubleManagerContainer;
